import { AutogenModelOtherChargeEdiCustomerLookup, AutogenRowOtherChargeEdiCustomerLookup } from "./autogen/AutogenModelOtherChargeEdiCustomerLookup";

export class ModelOtherChargeEdiCustomerLookup extends AutogenModelOtherChargeEdiCustomerLookup<RowOtherChargeEdiCustomerLookup> {
	constructor() {
		super(RowOtherChargeEdiCustomerLookup);
	}
}

export class RowOtherChargeEdiCustomerLookup extends AutogenRowOtherChargeEdiCustomerLookup {
}